// extracted by mini-css-extract-plugin
export default {"search":"OffersSearch_search__6cfgQ","icon":"OffersSearch_icon__RETQk"};